// extracted by mini-css-extract-plugin
export default {"categorySelect":"category-select__categorySelect__qSPdb"};